export default {"src":"/_next/static/media/icon-search-s.862697db.svg","height":19,"width":18};